import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=48b95fda"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=ts"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports